// extracted by mini-css-extract-plugin
module.exports = {"title":"Heading3_title__CscSv"};